import { render, staticRenderFns } from "./SelectGearbox.vue?vue&type=template&id=6fd9c052"
import script from "./SelectGearbox.vue?vue&type=script&lang=js"
export * from "./SelectGearbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports